import { SagaIterator } from 'redux-saga';
import { call, put, select, take, takeEvery } from 'redux-saga/effects';
import {
  GlobalActions,
  GlobalPut,
  NavigationRoute,
  ProvideVorhandeneVwgValidationPayload,
  ProvideVorvertragStatusValidationPayload,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../appState';
import { VwgActions } from '../vwgActions';

export function* handleVwgNavigationToAngebotSaga(): SagaIterator {
  yield takeEvery(
    VwgActions.HANDLE_VWG_NAVIGATION_TO_ANGEBOT,
    safeSaga(handleVwgNaviagtionToAngebot, App.VWG),
  );
}

export function* handleVwgNaviagtionToAngebot(): SagaIterator {
  const globalPut = GlobalPut.getInstance();
  const globalActions = new GlobalActions();
  const state: IAppState = yield select();

  yield call(
    globalPut.put,
    globalActions.requestMultiangebotAdressValidation({
      appId: App.VWG,
      angebotsId: state.angebotsId,
      risikoort: state.risikoort,
    }),
  );
  const addressValidationAction = yield take(GlobalActions.PROVIDE_MULTIANGEBOT_ADRESS_VALIDATION);
  const {
    validationResult: addressValidationError,
    appId: addressAppId,
    angebotsId: addressAngebotsId,
  }: ProvideVorhandeneVwgValidationPayload = addressValidationAction.payload;

  if (!(addressAppId === App.VWG && addressAngebotsId === state.angebotsId && addressValidationError == null )) {
    return;
  }

  yield call(
    globalPut.put,
    globalActions.requestVorvertragStatusValidation({
      appId: App.VWG,
      angebotsId: state.angebotsId,
      selectedVorvertragsNummern: state.vertragsoptionen?.vorvertragsNummern || [],
    }),
  );
  const contractValidationAction = yield take(
    GlobalActions.PROVIDE_VORVERTRAG_STATUS_VALIDATION,
  );
  const {
    validationResult: contractValidationError,
    appId: contractAppId,
    angebotsId: contractAngebotsId,
  }: ProvideVorvertragStatusValidationPayload = contractValidationAction.payload;

  if (!(contractAppId === App.VWG && contractAngebotsId === state.angebotsId && contractValidationError == null)) {
    return;
  }

  const vwgActions = new VwgActions();
  yield put(vwgActions.quoteDBRequested());
  yield put(vwgActions.preiseRequested());
  const navRoute: NavigationRoute = {
    appId: App.VWG,
    subroute: '/angebot',
  };
  return yield call(globalPut.put, globalActions.navigationRequested(navRoute));
}
